export function findAndUseLogoSize(imagesSizes: string[], targetSize = '3-1x1') {
  const foundIndex = imagesSizes.indexOf(targetSize);

  if (foundIndex !== -1) {
    return imagesSizes[foundIndex];
  } else {
    return imagesSizes[0];
  }
}
